function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useCallback } from "react";
import { User } from "@amzn/coral_com-amazon-passportusermanagementservice";
import { useDispatch, useSelector } from "react-redux";
import { updateUserLocaleAction } from "../actions/userManagementActions";
import { getUserProfileInfoSelector } from "../actions/userManagementActions/selectors";
export var useUpdateUserLocale = function() {
    var dispatch = useDispatch();
    var userObject = useSelector(getUserProfileInfoSelector);
    var updateUserLocale = useCallback(function(payload) {
        dispatch(updateUserLocaleAction.request(User.clone(_objectSpread({}, userObject, payload))));
    }, [
        dispatch,
        userObject
    ]);
    return {
        updateUserLocale: updateUserLocale
    };
};
export default useUpdateUserLocale;

//# sourceMappingURL=useUpdateUserLocale.js.map